import { connect } from 'react-redux'

import SearchMobileNavBar from './SearchMobileNavBar'
import { isLoggedIn } from '@src/redux/modules/auth'

const selector = state => ({
  isLoggedIn: isLoggedIn(state)
})

export default connect(selector)(SearchMobileNavBar)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchMobileNavBar/SearchMobileNavBarContainer.js